import type { ProductLogoMediumProps } from "../types";

/**
 * 中サイズのMarketplaceロゴアイコン
 */
export function ProductLogoMediumMarketplace({
  size = 40,
  ...props
}: ProductLogoMediumProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <rect width="40" height="40" rx="5.93472" fill="#1A2142" />
      <path
        d="M16.3792 29.9109C16.3792 31.0908 15.4227 32.0474 14.2427 32.0474C13.0628 32.0474 12.1062 31.0908 12.1062 29.9109C12.1062 28.7309 13.0628 27.7744 14.2427 27.7744C15.4227 27.7744 16.3792 28.7309 16.3792 29.9109Z"
        fill="#FCFCFD"
      />
      <path
        d="M27.7739 29.9109C27.7739 31.0908 26.8173 32.0474 25.6374 32.0474C24.4574 32.0474 23.5009 31.0908 23.5009 29.9109C23.5009 28.7309 24.4574 27.7744 25.6374 27.7744C26.8173 27.7744 27.7739 28.7309 27.7739 29.9109Z"
        fill="#FCFCFD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5375 21.6987C15.8612 21.9221 15.9425 22.3656 15.719 22.6893L14.1753 24.9257H27.0617C27.455 24.9257 27.7739 25.2446 27.7739 25.6379C27.7739 26.0312 27.455 26.3501 27.0617 26.3501H12.8184C12.5537 26.3501 12.3108 26.2032 12.1878 25.9688C12.0648 25.7345 12.0819 25.4512 12.2323 25.2333L14.5468 21.8802C14.7703 21.5565 15.2138 21.4752 15.5375 21.6987Z"
        fill="#FCFCFD"
      />
      <path
        d="M9.73044 12.4079C9.5101 11.9357 9.85476 11.3946 10.3758 11.3946H30.9286C31.4497 11.3946 31.7943 11.9357 31.574 12.4079L27.2535 21.6661C27.1365 21.9168 26.8848 22.0771 26.6082 22.0771H14.6963C14.4196 22.0771 14.1679 21.9168 14.0509 21.6661L9.73044 12.4079Z"
        fill="#57D7D9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.20117 9.25806C6.20117 8.86475 6.52002 8.5459 6.91334 8.5459H9.04984C9.32647 8.5459 9.57807 8.70609 9.69511 8.95674L15.7782 21.9834C15.9446 22.3398 15.7906 22.7636 15.4342 22.93C15.0779 23.0965 14.6541 22.9425 14.4876 22.5861L8.59641 9.97023H6.91334C6.52002 9.97023 6.20117 9.65138 6.20117 9.25806Z"
        fill="#FCFCFD"
      />
    </svg>
  );
}
